import React from 'react';
import ReactModal from 'react-modal';

import { CustomIcon } from 'components';
import useModalStyles from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose?: any;
  title: string;
  children: React.ReactElement;
  width?: string;
}

export default function Modal({
  isOpen,
  onRequestClose,
  title,
  children,
  width = '700px',
}: Props) {
  const { modal, overlay, header, close } = useModalStyles({ width });

  return (
    <ReactModal
      className={modal}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={overlay}
    >
      <>
        <button className={close} onClick={onRequestClose} type="button">
          <CustomIcon name="cross" />
        </button>
        <div className={header}>{title}</div>
        {children}
      </>
    </ReactModal>
  );
}
